import { Form } from "antd";
import React from "react";
import Input from "./BaseInput";
import AutoDismissToolTip from "@/components/AutoDismissToolTip";

interface SkuOriginalIdFieldProps {}

const SkuOriginalIdField: React.FC<SkuOriginalIdFieldProps> = (props) => {
    return (
        <AutoDismissToolTip
            placement="top"
            title={
                <p>
                    1、skuID最多可同时搜索10个
                    <br />
                    2、多个skuID间可用逗号、换行、空格分隔
                </p>
            }
            trigger="click"
        >
            <Form.Item label={<span className="search-field-label">SkuId</span>} name="skuOriginalIds">
                <Input allowClear />
            </Form.Item>
        </AutoDismissToolTip>
    );
};

export default React.memo(SkuOriginalIdField);
